import { deliveryMethodToStr } from '../components/delivery-method';
import { statusToStr } from '../components/status';
import { type PickTicketsFormSchema, type PickTicketsMutationSchema } from '../schemas';

export function pickTicketsFormToUpdate({
  pick_ticket_items: _,
  contacts,
  ...rest
}: PickTicketsFormSchema): PickTicketsMutationSchema {
  return {
    ...rest,
    client_id: rest.client?.id ?? null,
    contacts: contacts ? [contacts.id] : [],
    picker_id: rest.picker?.id ?? null,
    picker_type: rest.picker_type ?? null,
    status: statusToStr(rest?.status),
    delivery_method: deliveryMethodToStr(rest?.delivery_method),

    remove_items: rest.remove_items ?? false,
    why_removed: rest.why_removed?.value ?? null,

    delivery_address: rest.delivery_address?.map((address) => address.id) ?? [],
    attached_documents: rest.attached_documents?.map((file) => file.id) ?? [],
  };
}
